function checkPermission(currentUser, asset, operation) {
  if (
    currentUser &&
    currentUser.userGroup &&
    currentUser.userGroup.permission &&
    currentUser.userGroup.permission[asset][operation]
  ) {
    return true;
  }
  return false;
}

export default checkPermission;
